import PropTypes from 'prop-types';

import StoryLessonEpisode from './episodes/story_lesson_episode';
import LessonEpisode from './episodes/lesson_episode';
import AttachmentEpisode from './episodes/attachment_episode';

const ChapterList = ({ chapterList }) => {
  return (!chapterList.episodes) ? null : chapterList.episodes.map((episode) => {
    if (episode) {
      if (episode.layout_type === 'story_lesson') {
        return StoryLessonEpisode({ episode });
      } else if (episode.layout_type === 'lesson') {
        return LessonEpisode({ episode });
      } else if (episode.layout_type === 'attachment') {
        return AttachmentEpisode({ episode });
      }
      return null;
    }
    return null;
  });
};

ChapterList.propTypes = {
  chapterList: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default ChapterList;
